import { fetchTransactionById } from '@basqet-dashboard/common/api/transactions';
import { useCurrencies } from '@basqet-dashboard/common/hooks';
import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import { adaptLegacyTransaction, isLegacyTransaction } from './legacy-transaction-adapter';
import { TransactionDetails } from './transaction-details';

const TransactionDetailsPage = () => {
  const { transactionId } = useParams();
  const { availableCurrencies } = useCurrencies();
  const { data, isLoading, isError, refetch } = useQuery(
    ['transactionDetails', transactionId],
    () => fetchTransactionById(transactionId),
    { enabled: Boolean(transactionId), retry: false }
  );

  const details = useMemo(() => {
    const payload = data?.data;
    if (!isLegacyTransaction(payload)) return payload;
    return adaptLegacyTransaction(payload, availableCurrencies);
  }, [data, availableCurrencies]);

  if (isLoading) {
    return <div className="transaction-detail__state">Loading transaction details…</div>;
  }

  if (isError) {
    return (
      <div className="transaction-detail__state">
        <h1>Could not load transaction</h1>
        <p>Check your connection and try again.</p>
        <button type="button" onClick={() => refetch()}>
          Try again
        </button>
      </div>
    );
  }

  if (!details?.summary) {
    return (
      <div className="transaction-detail__state">
        <h1>Transaction not found</h1>
      </div>
    );
  }

  return <TransactionDetails details={details} transactionId={transactionId} />;
};

export { TransactionDetailsPage };
